import { Suspense } from "react";

const IsomorphicSuspense =
  typeof window !== "undefined" ? Suspense : ({ fallback }) => fallback;

export default IsomorphicSuspense;
